import { AppSettings } from './app.models';

export class SetSettings {
  static readonly type = '[AppState] SetSettings';
  constructor(public readonly appSettings: AppSettings) {}
}
